<template>
  <div :class="['cm-option', {disabled: disabled}]">
    <div class="cm-option-icon">
      <v-icon>{{ icon }}</v-icon>
    </div>
    <div class="cm-option-text">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionItem',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
  .AI-action-item {
    text-align: left;
    &:hover {
      background: #e4e4e4;
    }
  }

  .cm-option {
    display: flex;
    align-items: center;

    &.disabled {
      pointer-events: none;
      color: #ccc !important;

      .cm-option-icon {
        color: #ccc !important;
      }

      .cm-option-text {
        color: #ccc !important;
        font-size: 12px !important;
        font-weight: bold !important;
      }
    }

    &:hover {
      background-color: #eee;
    }

    .cm-option-icon {
      padding: 8px 20px 8px 20px;
    }

    .cm-option-text {
      display: block;
      padding: 5px 20px 5px 10px;
      font-size: 12px !important;
      font-weight: bold !important;
    }
  }
</style>